import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Projects from './Projects';
import Resume from './Resume';
import { Button } from 'react-bootstrap';
import Error from './Error';
import Education from './Education';

function Navbarport() {
  const [expanded, setExpanded] = useState(false);

  const toggleNavbar = () => setExpanded(!expanded);

  return (
    <BrowserRouter>
      <div className="sticky-top">
        <Navbar expanded={expanded} onToggle={toggleNavbar} collapseOnSelect expand="lg" className="navbar">
          <Container>
            <Navbar.Brand as={Link} to=""><strong>ANK</strong></Navbar.Brand>
            
            <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={toggleNavbar}>
              <i className={expanded ? "fa fa-times" : "fa fa-bars"} />
            </Navbar.Toggle>
            
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="nav">
                <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}><i className="fa-solid fa-house"></i> Home</Nav.Link>
                <Nav.Link as={Link} to="/about" onClick={() => setExpanded(false)}><i className="fa-solid fa-user"></i> About</Nav.Link>
                <Nav.Link as={Link} to="/education" onClick={() => setExpanded(false)}><i className="fa-solid fa-graduation-cap"></i> Education</Nav.Link>
                <Nav.Link as={Link} to="/projects" onClick={() => setExpanded(false)}><i className="fa-solid fa-diagram-project"></i> Projects</Nav.Link>
                <Nav.Link as={Link} to="/resume" onClick={() => setExpanded(false)}><i className="fa-solid fa-file"></i> Resume</Nav.Link>
              </Nav>
              <Nav>
                <Nav.Link as={Link} to="/contact">
                  <Button variant="outline-primary" onClick={() => setExpanded(false)}>Let's Connect</Button>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/education" element={<Education />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Navbarport;
